var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { IconClose } from '../../../atoms/icons/16x16/Close';
import { OverlayContainerStyle } from './OverlayContainerStyles';
export var OverlayContainer = function (_a) {
    var overlay = _a.overlay, cookieConsent = _a.cookieConsent, hideDismissIcon = _a.hideDismissIcon, handleBGClick = _a.handleBGClick, handleCloseIconClick = _a.handleCloseIconClick;
    var _b = useState(false), focused = _b[0], setFocused = _b[1];
    return (_jsx(OverlayContainerStyle, __assign({ id: "modal-background", cookieConsent: cookieConsent, hideDismissIcon: hideDismissIcon, onClick: handleBGClick, focused: focused }, { children: _jsxs("div", __assign({ className: "overlay-wrapper" }, { children: [_jsxs("div", __assign({ id: "overlay-close-button", className: "dismiss-wrapper", onClick: handleCloseIconClick }, { children: [_jsx(IconClose, {}), _jsx("button", { type: "button", className: "dismiss-button-hidden", onFocus: function () { return setFocused(true); }, onBlur: function () { return setFocused(false); }, onClick: function () { return handleCloseIconClick(); }, "aria-labelledby": "overlay-close-button" })] })), _jsx("div", __assign({ className: "content-wrapper" }, { children: overlay }))] })) })));
};
